import DashboardLayout from '../../../../layouts/DashboardLayout';
import ModalRoles from '../../components/PaqueteModal/ModalRoles';
import { useEffect, useState, useMemo } from 'react';
import { usePrivileges } from '../../../../hooks/usePrivileges';
import { DataTable } from '../../../../components/DataTable/DataTable';
import { useRoles } from '../../hooks/useRoles';
import { MODE } from '../../../../interaces/mode.interface';
import ActionsTable from '../../../../components/GenericComponents/ActionsTable';
import ConfirmationMessage from '../../../../components/GenericComponents/ConfirmationMessage';
import {
  TOAST_ERROR_IDS,
  TOAST_INFO_IDS,
  TOAST_SUCCESS_IDS,
} from '../../../../interaces/toast.ids.interface';
import { rolesApi } from '../../api/roles.api';
import toast from 'react-hot-toast';
import { updateDataWhenDelete } from '../../../../services/helpers';
import { ENUM_PERMISSIONS, ENUM_ROLES } from '../../../../interaces/enums/enums.interface';
import styles from "../../styles/styles.module.css"
function Roles() {
  const {
    entities,
    setEntities,
    fetchSearch,
    loading,
    searchValue,
    setSearchValue,
    onClear,
    dataPagination,
    setPageData,
    pageData,
    dataFilters,
    setDataFilters,
  } = useRoles();
  const [mode, setMode] = useState(MODE.CREATE);
  const [model, setModel] = useState();
  const [openModal, setOpenModal] = useState(false);
  const { hasPrivilege } = usePrivileges();

  useEffect(() => {
    fetchSearch();
  }, []);

  const handleEdit = (roleItem) => {
    setMode(MODE.UPDATE);
    setModel(roleItem);
    setOpenModal(true);
  };
  // Modal de confirmación para eliminar
  const [showConfirmationMessage, setShowConfirmationMessage] = useState(false);

  const handleDelete = async () => {
    try {
      await rolesApi.remove(model.id);
      updateDataWhenDelete(setEntities, model.id);
      toast.success(TOAST_SUCCESS_IDS.RECORD_DELETED_SUCCESSFULLY);
      setShowConfirmationMessage(false);
      setModel(null);
    } catch (error) {
      toast.error(error.message || error.error || TOAST_ERROR_IDS.SERVER_CONNECTION_ERROR, {
        id: TOAST_ERROR_IDS.SERVER_CONNECTION_ERROR,
      });
      setShowConfirmationMessage(false);
      setModel(null);
    }
  };

  const confirmDelete = (r) => {
    setModel(r);
    setShowConfirmationMessage(true);
  };

  const columns = [
    {
      accessorKey: 'name',
      header: 'NOMBRE',
    },
    {
      accessorKey: 'description',
      header: 'DESCRIPCIÓN',
    },
    {
      accessorKey: 'userCount',
      header: 'USUARIOS',
      cell: ({ row }) => {
        const count = row.original.userCount ?? 0;
        return (
          <span className={`${styles.numberUsers}`}>
            {count}
          </span>
        );
      },
    },
    {
      accessorKey: 'status',
      header: 'ESTADO',
      cell: ({ row }) => {
        const status = row.original.status;
        return (
          <span
            className={`
             status-register
              ${status ? 'status-color-active' : 'status-color-inactive'}
            `}
          >
            {status ? 'ACTIVO' : 'INACTIVO'}
          </span>
        );
      },
    },
    {
      accessorKey: 'privileges',
      header: 'PRIVILEGIOS',
      cell: ({ row }) => {
        const item = row.original;
        const count = item.privileges?.length ?? 0;
        return (
          <span className={`${styles.numberPrivileges}`}>
            {count}
          </span>
        );
      },
    },
    ...(hasPrivilege(ENUM_PERMISSIONS.MOD_ROLES_UPDATE) ||
    hasPrivilege(ENUM_PERMISSIONS.MOD_ROLES_DELETE)
      ? [
          {
            id: 'acciones',
            header: 'ACCIONES',
            cell: ({ row }) => {
              const item = row.original;
              const canEdit = hasPrivilege(ENUM_PERMISSIONS.MOD_ROLES_UPDATE);
              const canDelete = hasPrivilege(ENUM_PERMISSIONS.MOD_ROLES_DELETE);
              if (!canEdit && !canDelete) {
                return null;
              }

              const isSuperadmin = item.name === ENUM_ROLES.SUPERADMIN;
              const canDeleteThisRole = canDelete && !isSuperadmin && item.userCount <= 0;

              return (
                <ActionsTable
                  canDelete={canDeleteThisRole}
                  canEdit={canEdit}
                  handleEdit={() => handleEdit(item)}
                  handleDelete={() => confirmDelete(item)}
                  tienePermisoEditar={canEdit}
                  tienePermisoEliminar={canDeleteThisRole}
                />
              );
            },
          },
        ]
      : []),
  ];

  return (
    <DashboardLayout>
      <div className="page-container">
        <div className="page-header-row">
          <div className="page-title-wrapper">
            <p className="page-subtitle">
              Administra los roles y los paquetes de permisos del sistema.
            </p>
          </div>
        </div>

        <DataTable
          columns={columns}
          data={entities}
          searchPlaceholder="Buscar rol por nombre ..."
          totalRows={entities.length}
          loading={loading}
          emptyMessage="No se encontraron registros"
          onSearch={() => fetchSearch()}
          searchValue={searchValue}
          setSearchValue={setSearchValue}
          showCreate={hasPrivilege(ENUM_PERMISSIONS.MOD_ROLES_CREATE)}
          setOpenModal={setOpenModal}
          onClear={() => onClear()}
          showFilters={true}
          dataFilters={dataFilters}
          setDataFilters={setDataFilters}
          numberFilters={2}
          setMode={setMode}
          setModel={setModel}
          dataPagination={dataPagination}
          setPageData={setPageData}
          pageData={pageData}
        />

        {showConfirmationMessage && hasPrivilege(ENUM_PERMISSIONS.MOD_ROLES_DELETE) && (
          <ConfirmationMessage
            message={
              model
                ? `¿Estás seguro de que deseas eliminar el rol "${model.name}"?`
                : TOAST_INFO_IDS.ARE_YOU_SURE_WANT_TO_DELETE_THIS_RECORD
            }
            onConfirm={handleDelete}
            onCancel={() => {
              setShowConfirmationMessage(false);
              setModel(null);
            }}
          />
        )}
      </div>

      {openModal && (
        <ModalRoles
          onClose={() => setOpenModal(false)}
          model={model}
          mode={mode}
          setEntities={setEntities}
        />
      )}
    </DashboardLayout>
  );
}

export default Roles;
